import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";

const BENEFITS = [
  { ic: "🌟", h: "Featured placement", p: "Get positioned in our flagship discovery segment with maximum visibility to millions of users." },
  { ic: "🎁", h: "Earn from gifting", p: "Receive virtual gifts during rooms and calls that convert to real earnings." },
  { ic: "🔗", h: "Grow your socials", p: "Showcase your profile and let users explore your other handles, growing your following everywhere." },
];

const CRITERIA = [
  { h: "Public social profile", p: "An active, public profile with quality content and good engagement." },
  { h: "A real following", p: "Instagram/Snapchat: 2,000+ followers, or YouTube: 1,000+ subscribers (a plus, not a must)." },
  { h: "Great on camera", p: "Empathy, enthusiasm, and the ability to hold engaging conversations." },
];

export default function InstafrndCeleb() {
  return (
    <>
      <Helmet>
        <title>Become an Instafrnd Celeb — Instafrnd</title>
        <meta name="description" content="Get featured placement, earn from gifting, and grow your social following as an Instafrnd Celeb. Apply today." />
        <link rel="canonical" href="https://instafrnd.com/become-celeb" />
        <meta property="og:url" content="https://instafrnd.com/become-celeb" />
        <meta property="og:title" content="Become an Instafrnd Celeb — Instafrnd" />
        <meta property="og:description" content="Get featured placement, earn from gifting, and grow your social following as an Instafrnd Celeb. Apply today." />
      </Helmet>
      <PageHero
        eyebrow="Become an Instafrnd Celeb"
        title="Become a celeb on Instafrnd."
        subtitle="Join our community of creators, get discovered by millions, and turn your personality into a following — and an income."
      />

      <section className="section-pad">
        <div className="wrap">
          <div className="sec-head reveal">
            <div className="kicker">Creator benefits</div>
            <h2>Built for creators who connect.</h2>
          </div>
          <div className="card-grid">
            {BENEFITS.map((b, k) => (
              <div className="info-card reveal" key={k} style={{ transitionDelay: `${k * 0.08}s` }}>
                <div className="ic">{b.ic}</div>
                <h3>{b.h}</h3>
                <p>{b.p}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="features">
        <div className="wrap">
          <div className="sec-head reveal">
            <div className="kicker">What we look for</div>
            <h2>Here's what makes an Instafrnd Celeb.</h2>
          </div>
          <div className="card-grid">
            {CRITERIA.map((c, k) => (
              <div className="info-card reveal" key={k} style={{ transitionDelay: `${k * 0.08}s` }}>
                <div className="ic">✓</div>
                <h3>{c.h}</h3>
                <p>{c.p}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="cta-sec" style={{ paddingTop: 80 }}>
        <div className="wrap">
          <div className="cta reveal">
            <div className="kicker">Ready to shine?</div>
            <h2>Apply to become a Celeb.</h2>
            <p>Fill out the connect form and our team will reach out within 24 hours.</p>
            <Link className="btn btn-primary" to="/celeb-connect">Go to Celeb Connect Form →</Link>
          </div>
        </div>
      </section>
    </>
  );
}
